import { render } from "./CMSModalLink.vue?vue&type=template&id=047ea552&scoped=true&lang=pug"
import script from "./CMSModalLink.vue?vue&type=script&lang=ts"
export * from "./CMSModalLink.vue?vue&type=script&lang=ts"

import "./CMSModalLink.vue?vue&type=style&index=0&id=047ea552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-047ea552"

export default script